/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Ago", "azure-devops-ui/Card", "azure-devops-ui/Core/Observable", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Header", "azure-devops-ui/Link", "azure-devops-ui/Table", "azure-devops-ui/TooltipEx", "azure-devops-ui/Utilities/Provider", "azure-devops-ui/Util", "react", "../../Resources", "../Common/KubeCardWithTable", "../Common/Tags", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetailsStore", "../KubeFactory", "../Pods/PodsStore", "../Selection/SelectionActionCreator", "../Utils", "./WorkloadsActionsCreator", "./WorkloadsStore", "../ImageDetails/ImageDetailsActionsCreator", "./DeploymentsTable.scss"], function (require, exports, Ago_1, Card_1, Observable_1, String_1, Header_1, Link_1, Table_1, TooltipEx_1, Provider_1, Util_1, React, Resources, KubeCardWithTable_1, Tags_1, Constants_1, ActionsCreatorManager_1, StoreManager_1, ImageDetailsStore_1, KubeFactory_1, PodsStore_1, SelectionActionCreator_1, Utils_1, WorkloadsActionsCreator_1, WorkloadsStore_1, ImageDetailsActionsCreator_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DeploymentsTable = /** @class */ (function (_super) {
        __extends(DeploymentsTable, _super);
        function DeploymentsTable(props) {
            var _this = _super.call(this, props, {}) || this;
            // deployments have already been populated in store by KubeSummary parent component
            _this._onReplicaSetsFetched = function () {
                var storeState = _this._store.getState();
                _this.setState({
                    deploymentList: storeState.deploymentList,
                    replicaSetList: storeState.replicaSetList
                }, function () {
                    _this.props.markTTICallback && _this.props.markTTICallback({ "component": "DeploymentTable" });
                });
            };
            _this._setHasImageDetails = function () {
                _this.setState({});
            };
            _this._getColumns = function () {
                var columns = [];
                columns.push({
                    id: "replicasetName",
                    name: Resources.ReplicaSetText,
                    width: new Observable_1.ObservableValue(348),
                    renderCell: DeploymentsTable._renderReplicaSetNameCell
                });
                columns.push({
                    id: "imageName",
                    name: Resources.ImageText,
                    width: -72,
                    renderCell: _this._renderImageCell
                });
                columns.push({
                    id: "pods",
                    name: Resources.PodsText,
                    width: new Observable_1.ObservableValue(140),
                    renderCell: _this._renderPodsCountCell
                });
                columns.push({
                    id: "age",
                    name: Resources.AgeText,
                    width: -28,
                    renderCell: DeploymentsTable._renderAgeCell
                });
                return columns;
            };
            _this._renderPodsCountCell = function (rowIndex, columnIndex, tableColumn, deployment) {
                var replicaSet = _this._getSelectedReplicaSet(deployment);
                var podslist = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore).getState().podsList;
                var relevantPods = (podslist && podslist.items && podslist.items.filter(function (p) { return (replicaSet && Utils_1.Utils.isOwnerMatched(p.metadata, replicaSet.metadata.uid)) || false; }));
                var _onPodsClicked = (relevantPods && replicaSet) ? (function () { return KubeCardWithTable_1.onPodsColumnClicked(relevantPods, replicaSet, "ReplicaSet", _this._selectionActionCreator); }) : undefined;
                return KubeCardWithTable_1.renderPodsStatusTableCell(rowIndex, columnIndex, tableColumn, deployment.pods, deployment.statusProps, deployment.podsTooltip, _onPodsClicked, _this._podsLinkClassName);
            };
            _this._renderImageCell = function (rowIndex, columnIndex, tableColumn, deployment) {
                var textToRender = deployment.imageDisplayText || "";
                var imageId = deployment.imageId;
                var imageDetailsUnavailableTooltipText = "";
                var hasImageDetails = _this._imageDetailsStore.hasImageDetails(imageId);
                // If hasImageDetails is undefined, then image details promise has not resolved, so do not set imageDetailsUnavailable tooltip
                if (hasImageDetails === false) {
                    imageDetailsUnavailableTooltipText = String_1.localeFormat("{0} | {1}", deployment.imageTooltip || textToRender, Resources.ImageDetailsUnavailableText);
                }
                var itemToRender = hasImageDetails ?
                    React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true },
                        React.createElement(Link_1.Link, { className: Util_1.css("body-m text-ellipsis bolt-table-link", _this._imageLinkClassName), rel: "noopener noreferrer", excludeTabStop: true, onClick: function (e) {
                                e.preventDefault();
                                _this._onImageClick(imageId);
                            } }, textToRender))
                    : KubeCardWithTable_1.defaultColumnRenderer(textToRender, "body-m", imageDetailsUnavailableTooltipText);
                return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender, undefined, hasImageDetails ? "bolt-table-cell-content-with-link" : "");
            };
            _this._openDeploymentItem = function (event, tableRow, selectedItem) {
                var selectedReplicaSet = _this._getSelectedReplicaSet(selectedItem);
                if (selectedReplicaSet) {
                    var payload = {
                        item: selectedReplicaSet,
                        itemUID: selectedReplicaSet.metadata.uid,
                        showSelectedItem: true,
                        selectedItemType: "replica-set" /* ReplicaSetKey */
                    };
                    _this._selectionActionCreator.selectItem(payload);
                }
            };
            _this._onImageClick = function (imageId) {
                var showImageDetails = function (imageDetails) {
                    var payload = {
                        item: imageDetails,
                        itemUID: "",
                        showSelectedItem: true,
                        selectedItemType: "image-details" /* ImageDetailsKey */
                    };
                    _this._selectionActionCreator.selectItem(payload);
                };
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator).getImageDetails(imageId, showImageDetails);
            };
            _this._podsLinkClassName = "d-pods-link";
            _this._imageLinkClassName = "d-image-link";
            _this._workloadsActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(WorkloadsActionsCreator_1.WorkloadsActionsCreator);
            _this._selectionActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator);
            _this._imageDetailsStore = StoreManager_1.StoreManager.GetStore(ImageDetailsStore_1.ImageDetailsStore);
            _this._store = StoreManager_1.StoreManager.GetStore(WorkloadsStore_1.WorkloadsStore);
            _this._workloadsActionCreator.getReplicaSets(KubeFactory_1.KubeFactory.getKubeService());
            _this.state = { deploymentList: undefined, replicaSetList: undefined };
            _this._store.addListener(Constants_1.WorkloadsEvents.ReplicaSetsFetchedEvent, _this._onReplicaSetsFetched);
            _this._imageDetailsStore.addListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, _this._setHasImageDetails);
            return _this;
        }
        DeploymentsTable.prototype.render = function () {
            var _this = this;
            var deployments = this.state.deploymentList;
            var filteredDeployments = (deployments && deployments.items || []).filter(function (deployment) {
                return Utils_1.Utils.filterByName(deployment.metadata.name, _this.props.nameFilter);
            });
            if (filteredDeployments.length > 0) {
                return this._getDeploymentListView(filteredDeployments);
            }
            return null;
        };
        DeploymentsTable.prototype.componentWillUnmount = function () {
            this._store.removeListener(Constants_1.WorkloadsEvents.ReplicaSetsFetchedEvent, this._onReplicaSetsFetched);
            this._imageDetailsStore.removeListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, this._setHasImageDetails);
        };
        DeploymentsTable.prototype._getDeploymentListView = function (filteredDeployments) {
            var _this = this;
            var renderList = [];
            DeploymentsTable._generateDeploymentReplicaSetMap(filteredDeployments, this.state.replicaSetList).forEach(function (entry, index) {
                var items = DeploymentsTable._getDeploymentReplicaSetItems(entry.deployment, entry.replicaSets);
                var key = String_1.format("workloads-d-t-{0}", index);
                var tableProps = {
                    id: key,
                    showHeader: true,
                    showLines: true,
                    singleClickActivation: true,
                    itemProvider: new Provider_1.ArrayItemProvider(items),
                    ariaLabel: entry.deployment.metadata.name,
                    columns: _this._getColumns(),
                    onActivate: function (event, tableRow) {
                        var eventTarget = event && event.target;
                        // make sure all links have this classname
                        if (eventTarget && !eventTarget.classList.contains(_this._podsLinkClassName) && !eventTarget.classList.contains(_this._imageLinkClassName)) {
                            _this._openDeploymentItem(event, tableRow, items[tableRow.index]);
                        }
                    }
                };
                var deploymentCard = (React.createElement(Card_1.CustomCard, { className: "deployment-replica-with-pod-list k8s-card-padding bolt-table-card flex-grow bolt-card-no-vertical-padding", key: key },
                    React.createElement(Header_1.CustomHeader, null,
                        React.createElement(Header_1.HeaderTitleArea, null,
                            React.createElement(Header_1.HeaderTitleRow, null,
                                React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */, children: DeploymentsTable._getHeadingContent(entry.deployment) })),
                            React.createElement(Header_1.HeaderDescription, { className: "text-ellipsis" }, Resources.DeploymentText))),
                    React.createElement(Card_1.CardContent, { className: "deployment-replicaset-table", contentPadding: false },
                        React.createElement(Table_1.Table, __assign({}, tableProps)))));
                renderList.push(deploymentCard);
            });
            return renderList;
        };
        DeploymentsTable._generateDeploymentReplicaSetMap = function (deploymentList, replicaSetList) {
            var deploymentReplicaSetMap = [];
            deploymentList.forEach(function (d) {
                var replicas = replicaSetList && replicaSetList.items || [];
                var filteredReplicas = replicas.filter(function (r) { return DeploymentsTable._isReplicaSetForDeployment(d, r); }) || [];
                filteredReplicas.sort(function (a, b) {
                    // descending order
                    return DeploymentsTable._getCreationTime(b.metadata) - DeploymentsTable._getCreationTime(a.metadata);
                });
                deploymentReplicaSetMap.push({
                    deployment: d,
                    replicaSets: filteredReplicas
                });
            });
            return deploymentReplicaSetMap;
        };
        DeploymentsTable._getDeploymentReplicaSetItems = function (deployment, replicaSets) {
            var items = [];
            replicaSets.forEach(function (replicaSet, index) {
                if (replicaSet && replicaSet.spec && replicaSet.spec.replicas > 0) {
                    items.push(DeploymentsTable._getDeploymentReplicaSetItem(deployment, replicaSet, index, replicaSets.length));
                }
            });
            return items;
        };
        DeploymentsTable._getDeploymentReplicaSetItem = function (deployment, replica, index, replicaSetLength) {
            // todo :: annotations are taken from deployment for the first replica, rest of the replicas from respective replicas
            var annotations = index === 0 ? deployment.metadata.annotations : replica.metadata.annotations;
            var podslist = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore).getState().podsList;
            var pods = podslist && podslist.items || [];
            var imageId = Utils_1.Utils.getImageIdForWorkload(Utils_1.Utils.getFirstContainerName(replica.spec.template.spec), pods, replica.metadata.uid);
            if (imageId && (DeploymentsTable._imageList.length <= 0 || DeploymentsTable._imageList.findIndex(function (img) { return String_1.equals(img, imageId); }) < 0)) {
                DeploymentsTable._imageList.push(imageId);
            }
            var _a = Utils_1.Utils.getImageText(replica.spec.template.spec), imageText = _a.imageText, imageTooltipText = _a.imageTooltipText;
            return __assign({ name: index > 0 ? "" : deployment.metadata.name, deploymentId: deployment.metadata.uid, replicaSetId: replica.metadata.uid, replicaSetName: replica.metadata.name, pipeline: Utils_1.Utils.getPipelineText(annotations), showRowBorder: (replicaSetLength === (index + 1)), deployment: deployment, imageDisplayText: imageText, imageId: imageId, creationTimeStamp: replica.metadata.creationTimestamp, kind: replica.kind || "ReplicaSet", imageTooltip: imageTooltipText }, Utils_1.Utils.getPodsStatusProps(replica.status.readyReplicas, replica.status.replicas));
        };
        DeploymentsTable._getCreationTime = function (metadata) {
            return (!!metadata.creationTimestamp ? new Date(metadata.creationTimestamp) : new Date()).getTime();
        };
        DeploymentsTable._isReplicaSetForDeployment = function (deployment, replica) {
            return !!deployment && !!replica
                && replica.metadata.namespace.toLowerCase() === deployment.metadata.namespace.toLowerCase()
                && replica.metadata.ownerReferences && replica.metadata.ownerReferences.length > 0
                && replica.metadata.ownerReferences[0].uid.toLowerCase() === deployment.metadata.uid.toLowerCase();
        };
        DeploymentsTable._renderReplicaSetNameCell = function (rowIndex, columnIndex, tableColumn, deployment) {
            var itemToRender = KubeCardWithTable_1.defaultColumnRenderer(deployment.replicaSetName || "", "body-m font-weight-semibold");
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
        };
        DeploymentsTable._renderAgeCell = function (rowIndex, columnIndex, tableColumn, deployment) {
            var createdDate = deployment.creationTimeStamp ? deployment.creationTimeStamp : new Date();
            var itemToRender = React.createElement(Ago_1.Ago, { className: "body-m", date: new Date(createdDate) });
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
        };
        DeploymentsTable._getHeadingContent = function (deployment) {
            return (React.createElement("div", { className: "flex-row flex-center" },
                React.createElement("div", null, deployment.metadata.name),
                React.createElement(Tags_1.Tags, { className: "deployment-tbl-heading-labels body-s", items: deployment.metadata.labels })));
        };
        DeploymentsTable.prototype._getSelectedReplicaSet = function (selectedItem) {
            // have one selection store, raise action to send selectedItem, in the store
            if (selectedItem && selectedItem.replicaSetId) {
                var selectedItemReplicaSetUId_1 = selectedItem.replicaSetId.toLowerCase();
                var replicas = this.state.replicaSetList;
                var filteredReplicas = (replicas && replicas.items || []).filter(function (r) {
                    return r.metadata.uid.toLowerCase() === selectedItemReplicaSetUId_1;
                });
                return filteredReplicas[0];
            }
            return null;
        };
        DeploymentsTable._imageList = [];
        return DeploymentsTable;
    }(React.Component));
    exports.DeploymentsTable = DeploymentsTable;
});
